var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSocialHelp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7732 14.1073C20.7732 16.7473 18.6399 18.894 15.9999 18.894C13.3599 18.894 11.2266 16.7473 11.2266 14.1073C11.2266 11.4673 13.3599 9.33398 15.9999 9.33398C18.6399 9.33398 20.7732 11.4673 20.7732 14.1073Z",
    fill: "#B7CCFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.273 28.7063C22.2306 28.9695 20.9988 29.0909 19.5537 29.0909H12.4468C11.0017 29.0909 9.76988 28.9695 8.72754 28.7063C8.98813 26.0748 12.1507 24 16.0003 24C19.8498 24 23.0124 26.0748 23.273 28.7063Z",
    fill: "#A020FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1868 28.827C23.0135 29.1737 21.6268 29.3337 20.0001 29.3337H12.0001C10.3735 29.3337 8.98681 29.1737 7.81348 28.827C8.10681 25.3603 11.6668 22.627 16.0001 22.627C20.3335 22.627 23.8935 25.3603 24.1868 28.827Z",
    stroke: "#081E54",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0003 2.66602H12.0003C5.33366 2.66602 2.66699 5.33268 2.66699 11.9993V19.9993C2.66699 25.0393 4.18699 27.7993 7.81366 28.826C8.10699 25.3593 11.667 22.626 16.0003 22.626C20.3337 22.626 23.8937 25.3593 24.187 28.826C27.8137 27.7993 29.3337 25.0393 29.3337 19.9993V11.9993C29.3337 5.33268 26.667 2.66602 20.0003 2.66602ZM16.0003 18.8927C13.3603 18.8927 11.227 16.746 11.227 14.106C11.227 11.466 13.3603 9.33268 16.0003 9.33268C18.6403 9.33268 20.7737 11.466 20.7737 14.106C20.7737 16.746 18.6403 18.8927 16.0003 18.8927Z",
    stroke: "#081E54",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7732 14.1073C20.7732 16.7473 18.6399 18.894 15.9999 18.894C13.3599 18.894 11.2266 16.7473 11.2266 14.1073C11.2266 11.4673 13.3599 9.33398 15.9999 9.33398C18.6399 9.33398 20.7732 11.4673 20.7732 14.1073Z",
    stroke: "#081E54",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialHelp);
export default __webpack_public_path__ + "static/media/SocialHelp.25f5a127be8973010c2b95e02bfaed88.svg";
export { ForwardRef as ReactComponent };